import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthenticationGuard, IsAuthenticatedGuard } from "src/common";
import { MainLayoutComponent } from "src/layouts";
import {
  EmptyComponent,
  ForgetPasswordComponent,
  LoginComponent,
  ChangePasswordComponent,
  NewPasswordComponent,
  RequestCreateComponent,
  RequestDetailsComponent,
  RequestEditComponent,
  RequestsComponent,
  SupplierOfferListSsy1200listComponent,
  SupplierRoundListSsy1190listComponent,
  SupplierRoundListSsy1230detailDetailsComponent,
  TestComponent,
  UnauthorizedComponent,
  SupplierAuctionOfferListSsy1250listComponent,
  SupplierAuctionOfferListSsy1280detailDetailsComponent,
  SupplierAuctionOfferListSsy1280detailEditComponent,
  SupplierAuctionOfferListSsy1280detailCreateComponent, SupplierAuctionRangListSsy1260listComponent, SupplierUserComponent, LogoutComponent, HomePageComponent
} from "src/views";
import { UsageConditionsReviewComponent } from "../views/login/usage-conditions-review/usage-conditions-review.component";
import { ConfirmedProcurementsComponent } from "src/views/confirmed-procurements/confirmed-procurements.component";


const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthenticationGuard],
    children: [
      {
        path: '',
        component: EmptyComponent,
        canActivate: [AuthenticationGuard],
        children: [
          {
            path: '',
            //component: HomePageComponent
            component: LoginComponent
          }
        ]
      },
      {
          path: 'home',
          component: HomePageComponent,
      },
      // {
      //   path: 'login',
      //   component: LoginComponent
      // },
      {
        path: 'logout',
        component: LogoutComponent,
      },
      {
        path: 'unauthorized',
        component: UnauthorizedComponent
      },
      {
        path: 'forget-password',
        component: ForgetPasswordComponent
      },
      {
        path: 'new-password/:id',
        component: NewPasswordComponent
      },
      {
        path: 'change-password',
        component: ChangePasswordComponent
      },
      {
        path: 'usage-conditions',
        component: UsageConditionsReviewComponent,
      },
      {
        path: 'supplier-user',
        component: SupplierUserComponent,
      },
      {
        path: 'requests',
        canActivate: [IsAuthenticatedGuard],
        component: EmptyComponent,
        children: [
          {
            path: '',
            component: RequestsComponent
          },
          {
            path: 'details/:id',
            component: RequestDetailsComponent
          },
          {
            path: 'edit/:id',
            component: EmptyComponent,
            children: [
              {
                path: '',
                component: RequestEditComponent
              }
            ]
          },
          {
            path: 'create',
            component: RequestCreateComponent
          }
        ]
      },
      {
        path: 'supplier-rounds',
        component: EmptyComponent,
        children: [
          {
            path: '',
            component: SupplierRoundListSsy1190listComponent
          },
          {
            path: 'details/:id',
            component: SupplierRoundListSsy1230detailDetailsComponent
          },
          {
            path: 'confirmed-procurements/:requestRoundSupplierId',
            component: ConfirmedProcurementsComponent
          }
        ]
      },
      {
        path: 'supplier-offers',
        component: EmptyComponent,
        children: [
          {
            path: ':id',
            component: SupplierOfferListSsy1200listComponent
          },
          {
            path: 'details/:supplierOfferId',
            component: RequestDetailsComponent
          },
          {
            path: 'edit/:requestRoundSupplierId/:supplierOfferId',
            component: RequestEditComponent
          },
          {
            path: 'create/:requestRoundId',
            component: RequestCreateComponent
          }
        ]
      },
      {
        path: 'auctions',
        component: EmptyComponent,
        children: [
          {
            path: '',
            component: SupplierAuctionOfferListSsy1250listComponent
          },
          {
            path: 'details/:id',
            component: SupplierAuctionOfferListSsy1280detailDetailsComponent
          },
          {
            path: 'edit/:id/:requestRoundSupplierId',
            component: SupplierAuctionOfferListSsy1280detailEditComponent
          },
          {
            path: 'rang-list/:id/:auctionId',
            component: SupplierAuctionRangListSsy1260listComponent
          },
          {
            path: 'create/:requestRoundSupplierId',
            component: SupplierAuctionOfferListSsy1280detailCreateComponent
          }
        ]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
